import { PresenceDialog } from 'Components/PresenceDialog';
import { Banner } from 'Components/shared/Banner';
import { MobXProviderContext, observer } from 'mobx-react';
import React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { getBannerVariantProps } from '../helpers/getBannerVariantProps';
import { BannerLayoutProps } from '../index.types';

export const DNDBannerWrapper = observer(({ variant }: BannerLayoutProps) => {
  const { ui } = React.useContext<RootStoreProps>(MobXProviderContext);

  const [showMessageStatusModal, setShowMessageStatusModal] =
    React.useState<boolean>(false);

  return (
    <>
      <Banner
        isFullWidth
        type="info"
        id="dnd-banner-wrapper"
        message="Do not disturb is enabled. While on, your calls will be hidden in the apps."
        showCloseButton={false}
        {...getBannerVariantProps(variant)}
        action={[
          {
            label: 'Dismiss',
            onClick: () => {
              ui.setShouldShowDndBanner(false);
            },
          },
          {
            label: 'Change',
            onClick: () => setShowMessageStatusModal(true),
          },
        ]}
      />

      <PresenceDialog
        open={showMessageStatusModal}
        onClose={() => setShowMessageStatusModal(!showMessageStatusModal)}
      />
    </>
  );
});
